module.exports = ".mdi-close-circle-o {\n    font-size: 48px;\n    color: #e04545;\n}"